import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { endSession } from '../hooks/useSessionCleanup';
import { useTranslation } from 'react-i18next';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

const LogoutButton = ({ subscriptionId, onLogout }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(true);
  const hideTimeoutRef = useRef(null);

  useEffect(() => {
    const handleMouseMove = () => {
      setVisible(true);
      clearTimeout(hideTimeoutRef.current);
      hideTimeoutRef.current = setTimeout(() => setVisible(false), 3000);
    };

    window.addEventListener('mousemove', handleMouseMove);
    hideTimeoutRef.current = setTimeout(() => setVisible(false), 3000);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      clearTimeout(hideTimeoutRef.current);
    };
  }, []);

  const handleLogout = async () => {
    if (!subscriptionId) return;
    try {
      // Call logout endpoint which clears cookie and removes session
      await axios.post(`${API_BASE}/api/auth/logout`, {}, {
        withCredentials: true
      });
      
      // Also call session end for cleanup
      endSession(subscriptionId);
      
      alert(t('logoutButton.sessionEnded'));
      
      // Call parent's logout handler to update state (don't reload)
      if (onLogout) {
        onLogout();
      }
    } catch (error) {
      alert(t('logoutButton.sessionEndFailed'));
      console.error('Logout failed:', error);
    }
  };

  return (
    <button
      onClick={handleLogout}
      className={`logout-button ${visible ? '' : 'hidden'}`}
    >
      {t('logoutButton.logout')}
    </button>
  );
};

export default LogoutButton;
